import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { DateText } from '@/components/functional/Format/DateText/DateText';
import { Text } from '@/components/ui/Typography/Body/Text';
import { Head } from '@/components/ui/Typography/Heading/Head';
/**
 * セミナー用の日付表示コンポーネント
 * @param props
 * @constructor
 */
export const SeminarCliScheduleDate = (props) => {
    const { className = '', prefix, value } = props;
    return (_jsxs("div", Object.assign({ className: clsx('flex items-baseline', 'gap-x-4', className) }, { children: [prefix && (_jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'xs' }, { children: prefix }))), _jsxs("div", Object.assign({ className: clsx('flex items-baseline') }, { children: [_jsx(Text, Object.assign({ color: 'base', isBold: true, size: 'xs' }, { children: _jsx(DateText, { format: 'yyyy.', value: value }) })), _jsx(Head, Object.assign({ className: 'text-head-md leading-6', color: 'base', size: 'none' }, { children: _jsx(DateText, { format: 'MM.dd', value: value }) })), _jsx(Text, Object.assign({ color: 'textGray', isBold: true, size: 'xs' }, { children: _jsx(DateText, { format: '（eee）', value: value }) }))] }))] })));
};
